import { TContact } from 'types/contact';

import { CRMAPIBase } from '@api/crmApiBase';
import { ContactListResp } from '@api/responseModels/contact/contactListResponse';
import { ContactResp } from '@api/responseModels/contact/contactResponse';
import { RequestResult } from '@api/responseModels/requestResult';

class ContactsGroup extends CRMAPIBase {
    /**
     * Создание контакта
     * @param contact Данные контакта
     * @returns Результат запроса
     */
    async createContact(contact: TContact & { crm_id: number }): Promise<RequestResult<ContactResp>> {
        const result = await this.post<ContactResp>('/contacts', contact);
        return result;
    }

    /**
     * Получение списка контактов
     * @param crm_id ID CRM
     * @param page Страница
     * @param per_page Записей на страницу
     * @returns Результат запроса
     */
    async getContactList(params: {
        crm_id: number;
        page?: number;
        per_page?: number;
        query?: string;
    }): Promise<RequestResult<ContactListResp>> {
        const result = await this.get<ContactListResp>('/contacts', {
            ...params,
            per_page: params.per_page || 10,
        });
        return result;
    }

    /**
     * Получение одного контакта
     * @param id ID контакта
     * @param crm_id ID CRM
     * @returns Результат запроса
     */
    async getContact(id: number, crm_id: number): Promise<RequestResult<ContactResp>> {
        const result = await this.get<ContactResp>(`/contacts/${id}`, { crm_id });
        return result;
    }

    /**
     * Обновление контакта
     * @param id ID контакта
     * @param contact Данные контакта
     * @returns Результат запроса
     */
    async updateContact(
        id: number,
        contact: TContact & { crm_id: number }
    ): Promise<RequestResult<ContactResp>> {
        const result = await this.put<ContactResp>(`/contacts/${id}`, contact);
        return result;
    }

    /**
     * Удаление контакта
     * @param id ID контакта
     * @param crm_id ID CRM
     * @returns Результат запроса
     */
    async deleteContact(id: number, crm_id: number): Promise<RequestResult<ContactResp>> {
        const result = await this.delete<ContactResp>(`/contacts/${id}`, { crm_id });
        return result;
    }
}

export { ContactsGroup };

